module.exports = __webpack_public_path__ + "static/dac-1b5cef3857ac7a2c8443ae97face7251.png";